module.exports = __webpack_public_path__ + "img/fedora.479a6866.png";